import React from "react";
import styled, { css } from "styled-components";

interface ApplicationInformationContainerProps extends React.HTMLAttributes<HTMLDivElement> {
	isDocument?: boolean;
}

export const ApplicationInformationContainer: React.FC<ApplicationInformationContainerProps> = ({
	isDocument,
	children,
}) => {
	return <Content isDocument={isDocument}>{children}</Content>;
};

const Content = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "isDocument",
})<{ isDocument?: boolean }>`
	display: flex;
	${({ isDocument }) =>
		isDocument
			? css`
					flex-direction: column;
					align-items: flex-start;
					gap: 10px;
				`
			: css`
					align-items: center;
					gap: 130px;
					justify-content: space-between;
				`}
`;
